import React, { Component, Fragment } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { Typography } from 'rmwc/Typography';
import { Text } from '../../components/Text';
import Hint from '../../components/ModuleDrawer/Hint';
import { DynamicWrapper } from '../../components/util/DynamicWrapper';
import { Radio } from 'rmwc/Radio';
import { SelectControl } from '../../components/controls/SelectControl';
import { backOnboarding, continueOnboarding, pathAware } from '../../actions/onboardingActions';

const StyledAnswerRow = styled.div`
  width: 80%;
`;

const homeValueSpec = {
  field_type: 'single_choice',
  options: [75000, 150000, 250000, 350000, 450000, 625000, 875000, 1250000, 1750000, 2250000, 2750000, 3500000],
  option_data: {
    '75000': { label: '$50,000-$99,999' },
    '150000': { label: '$100,000-$199,999' },
    '250000': { label: '$200,000-$299,999' },
    '350000': { label: '$300,000-$399,999' },
    '450000': { label: '$400,000-$499,999' },
    '625000': { label: '$500,000-$749,999' },
    '875000': { label: '$750,000-$999,999' },
    '1250000': { label: '$1,000,000-$1,499,999' },
    '1750000': { label: '$1,500,000-$1,999,999' },
    '2250000': { label: '$2,000,000-$2,499,999' },
    '2750000': { label: '$2,500,000-$2,999,999' },
    '3500000': { label: '$3,000,000+' },
  },
};

const mortgageSpec = {
  field_type: 'single_choice',
  options: [0, 25000, 75000, 150000, 250000, 350000, 450000, 625000, 875000, 1250000, 1750000, 2500000],
  option_data: {
    '0': { label: 'No Mortgage' },
    '25000': { label: '$1-$49,999' },
    '75000': { label: '$50,000-$99,999' },
    '150000': { label: '$100,000-$199,999' },
    '250000': { label: '$200,000-$299,999' },
    '350000': { label: '$300,000-$399,999' },
    '450000': { label: '$400,000-$499,999' },
    '625000': { label: '$500,000-$749,999' },
    '875000': { label: '$750,000-$999,999' },
    '1250000': { label: '$1,000,000-$1,499,999' },
    '1750000': { label: '$1,500,000-$1,999,999' },
    '2500000': { label: '$2,000,000+' },
  },
};

class Housing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ownsPrimaryResidence: props.qna_hash.ownsPrimaryResidence ? props.qna_hash.ownsPrimaryResidence.answer : null,
      homeValue: props.qna_hash.homeValue ? props.qna_hash.homeValue.answer : '',
      mortgage: props.qna_hash.mortgage
        ? props.qna_hash.mortgage.answer
        : {
            remainingPrincipal: '',
            interestRate: 0,
            monthlyPayment: 0,
          },
    };
  }

  componentDidMount() {
    this.props.pathAware('ownsPrimaryResidence');
  }

  componentWillReceiveProps(props) {
    if (props.qna_hash.ownsPrimaryResidence) {
      this.setState({
        ownsPrimaryResidence: props.qna_hash.ownsPrimaryResidence.answer,
      });
    }
    if (props.qna_hash.homeValue) {
      this.setState({
        homeValue: props.qna_hash.homeValue.answer,
        mortgage: props.qna_hash.mortgage.answer,
      });
    }
  }

  _onContinue = () => {
    const { onContinue, qna_hash, qna_stack } = this.props;

    let frame = {
      ownsPrimaryResidence: {
        question: 'Do you own your primary residence, or are you renting? (true = own)',
        answer: this.state.ownsPrimaryResidence,
      },
    };

    if (this.state.ownsPrimaryResidence) {
      frame.homeValue = {
        question: 'Approximately what is your home worth?',
        answer: this.state.homeValue,
      };
      frame.mortgage = {
        question: 'Do you have a mortgage on your home?',
        answer: this.state.mortgage,
      };
    }

    this.props.continueOnboarding(qna_stack, qna_hash, frame).then(onContinue);
  };

  _canContinue = () => {
    return (
      this.state.ownsPrimaryResidence !== null &&
      (this.state.ownsPrimaryResidence
        ? this.state.homeValue !== '' &&
          this.state.mortgage.remainingPrincipal !== '' &&
          this.state.monthlyPayment !== '' &&
          this.state.interestRate !== ''
        : true)
    );
  };

  _onBack = () => {
    this.props.backOnboarding(this.props.qna_stack).then(() => this.props.onBack());
  };

  onChange = (evt, field) => {
    this.setState({ [field]: evt.target.value });
  };

  onChangeMortgage = (evt, field) => {
    const mortgage = this.state.mortgage;
    mortgage[field] = evt.target.value;
    this.setState({ mortgage });
  };

  render() {
    const { wrapper, qna_stack } = this.props;
    const { ownsPrimaryResidence } = this.state;

    return (
      <DynamicWrapper
        wrapper={wrapper}
        onContinue={this._onContinue}
        onBack={this._onBack}
        canContinue={this._canContinue()}
        helperText={<Hint>Don't worry about getting it perfect! You'll be able to update this information later.</Hint>}
      >
        <div style={{ width: '90%', display: 'flex', justifyContent: 'center' }}>
          <Text use="headline6">Do you own your primary residence, or are you renting?</Text>
        </div>
        <div className="mb-4">
          <Radio
            id="ownsPrimaryResidenceTrue"
            value="yes"
            checked={ownsPrimaryResidence === true}
            onChange={evt => this.setState({ ownsPrimaryResidence: true })}
          >
            <Typography use="subtitle1">Own</Typography>
          </Radio>

          <span className="ml-4">
            <Radio
              id="ownsPrimaryResidenceFalse"
              value="no"
              checked={ownsPrimaryResidence === false}
              onChange={evt => this.setState({ ownsPrimaryResidence: false })}
            >
              <Typography use="subtitle1">Rent</Typography>
            </Radio>
          </span>
        </div>
        {ownsPrimaryResidence && (
          <div className="mt-3 mb-4" style={{ width: '100%', borderTop: '1px solid #e0e0e0' }} />
        )}
        {ownsPrimaryResidence && (
          <Fragment>
            <Text use="headline6">Roughly what is your home worth?</Text>
            <div
              style={{
                width: '90%',
                margin: 'auto',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
              }}
            >
              <Text className="mb-0" use="body1">
                Try to estimate the price you'd get if you sold it today. A rough guess is okay!
              </Text>
            </div>

            <StyledAnswerRow>
              <SelectControl
                id="homeValue"
                label="Approximate Home Value"
                value={this.state.homeValue}
                spec={homeValueSpec}
                onChange={evt => this.onChange(evt, 'homeValue')}
              />
            </StyledAnswerRow>

            <div className="mt-4" style={{ width: '100%', borderTop: '1px solid #e0e0e0' }} />
            <Text className="mt-4" use="headline6">
              Do you have a mortgage?
            </Text>
            <div
              style={{
                width: '90%',
                margin: 'auto',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
              }}
            >
              <Text className="mb-0" use="body1">
                If so, let us know roughtly how much of the loan amount is still outstanding.
              </Text>
            </div>
            <StyledAnswerRow>
              <SelectControl
                id="remainingPrincipal"
                label="Mortgage Principal Remaining"
                value={this.state.mortgage.remainingPrincipal}
                spec={mortgageSpec}
                onChange={evt => this.onChangeMortgage(evt, 'remainingPrincipal')}
              />
            </StyledAnswerRow>
          </Fragment>
        )}
      </DynamicWrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    qna_hash: state.onboarding.qna_hash,
    qna_stack: state.onboarding.qna_stack,
  };
}

export default connect(mapStateToProps, { backOnboarding, continueOnboarding, pathAware })(Housing);
